import { render, staticRenderFns } from "./rankList.vue?vue&type=template&id=0cc4752a&scoped=true&"
import script from "./rankList.vue?vue&type=script&lang=js&"
export * from "./rankList.vue?vue&type=script&lang=js&"
import style0 from "./rankList.vue?vue&type=style&index=0&id=0cc4752a&prod&lang=scss&"
import style1 from "./rankList.vue?vue&type=style&index=1&id=0cc4752a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4752a",
  null
  
)

export default component.exports